// src/components/Footer.jsx
import React from 'react';
import '../styles/Footer.css'; // Add your CSS styles for the footer

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          Email: <a href="mailto:City.2007hosur@gmail.com">City.2007hosur@gmail.com</a> |
          Mobile: <a href="tel:+917373734618">7373734618</a> | 
          <a href="tel:+919443083716">9443083716</a>
        </p>
       
      </div>
      <div className="footer-copyright">
        <p>&copy; {new Date().getFullYear()} City Enterprises. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
